
export default {
	namespaced: true,

	state: window.__INITIAL_STATE__.cart || {
		addedIds: new Set([]),
		quantityByIds: {}
	},

	mutations: {
		ADD_ITEM_TO_CART(state, { itemId, quantity })
		{
			state.addedIds.add(itemId);

			if (state.quantityByIds[itemId])
			{
				state.quantityByIds[itemId] += quantity;
			}
			else
			{
				Vue.set(state.quantityByIds, itemId, quantity);
			}
		}, 

		SET_QUANTITY(state, { itemId, quantity })
		{
			if (quantity > 0)
			{
				state.addedIds.add(itemId);
			}
			else
			{
				state.addedIds.delete(itemId);
			}

			Vue.set(state.quantityByIds, itemId, quantity);
		},

		REMOVE_ITEM_FROM_CART(state, { itemId })
		{
			state.addedIds.delete(itemId);
			Vue.set(state.quantityByIds, itemId, 0);
		},

		SET_STATE(state, {addedIds, quantityByIds})
		{
			Vue.set(state, 'addedIds', new Set(addedIds));
			Vue.set(state, 'quantityByIds', quantityByIds);
		}
	},

	actions: {
		async fetch({ commit }) {
			const result = await BX.ajax.runAction('redsign:b2bportal.api.cart.fetch');

			if (result.data)
			{
				commit('SET_STATE', result.data);
			}
		}
	}
}